export class DbServerErrors {

  public message: string;
  public fields: any;

  public static create(responseError: any, serverFieldNamesMap: object = {}): DbServerErrors {
    const serverErrors: DbServerErrors = new DbServerErrors();
    serverErrors.message = responseError.message || responseError.msg;
    serverErrors.fields = {};
    for (let key in responseError.errors) {
      if (!responseError.errors.hasOwnProperty(key)) {
        continue;
      }

      const messages: string[] = responseError.errors[key];
      if (serverFieldNamesMap[key]) {
        key = serverFieldNamesMap[key];
      }
      serverErrors.fields[key] = messages;
    }
    // for stripe error
    if (responseError.message_code === 'stripe_error') {
      serverErrors.fields['stripe'] = responseError.message;
    }

    return serverErrors;
  }

}
